module.exports = __webpack_public_path__ + "static/scale-model-of-greystone-park-in-bakersfield-california-eaf4f10aa9e7f37c7df8638cb312442e.png";